import { NeedsResourceDetailsDto } from '@act/shared/data-transfer-objects';
import { userAppSelectors } from 'redux/slices/usersSlice.slice';
import { CollapsibleHistoryCard } from './CollapsibleHistoryCard';
import { getHistoryEntryDateLine } from './HistoryCardHelpers';
import AddIcon from '@mui/icons-material/Add';

interface NeedResourceDetailsHistoryEntryProps {
  resourceDetails: NeedsResourceDetailsDto;
}

const NeedResourceDetailsHistoryEntry = ({
  resourceDetails,
}: NeedResourceDetailsHistoryEntryProps) => {
  const creatorName = userAppSelectors.useSelectUserById(
    resourceDetails?.creatorId
  )?.name;

  return (
    <CollapsibleHistoryCard
      title={`Resource referred: ${resourceDetails?.resourceName}`}
      subtitle={getHistoryEntryDateLine(
        resourceDetails?.createdAt,
        creatorName
      )}
      icon={<AddIcon />}
    />
  );
};

export default NeedResourceDetailsHistoryEntry;
